module.exports = __webpack_public_path__ + "fonts/f58f272c1b0d5d4300efd927f9861ed6.svg";